<template>
  <div class="home">
    <div class="title">Clips by stream</div>
    <div class="description">Easily browse and manage your clips</div>
    <button @click="onLoginClick" class="button">Login</button>
  </div>
</template>

<script>
import { STATE_ITEM, CLIENT_ID } from "../settings";

export default {
  name: "home",
  methods: {
    onLoginClick() {
      const state = (Date.now() * Math.random()).toString();
      localStorage.setItem(STATE_ITEM, state);
      window.location = `https://id.twitch.tv/oauth2/authorize?client_id=${CLIENT_ID}&redirect_uri=${process.env.VUE_APP_REDIRECT_URL}&response_type=token&state=${state}`;
    }
  }
};
</script>

<style scoped>
.home {
  @apply flex flex-col text-center items-center justify-center p-8 h-full w-full;
}
.button {
  @apply px-4 py-2 bg-purple-500 text-white font-semibold rounded-md inline-flex;
}

.title {
  @apply font-bold text-xl pb-2;
}

.description {
  @apply font-light pb-4 text-sm;
}
</style>
